import React, { useEffect } from 'react'
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import {
    TextField, Paper, Box, Button, Autocomplete
} from '@mui/material'
const buttonContent = {
    margin: '16px 8px 0',
    // width: '150px',
    float: 'right'
}

export default function ViewInstructionDialog(props) {
    const [selectedParticipantObj, setSelectedParticipantObj] = React.useState(null);
    const [participantList, setParticipantList] = React.useState([]);
    const [instructionText, setInstructionText] = React.useState('');

    useEffect(() => {
        selectedParticipants('')
        setParticipantList(props.users && props.users)
    }, [])
    const handlePrev = () => {
        const previousObject = participantList[participantList.indexOf(selectedParticipantObj) - 1];
        setSelectedParticipantObj(previousObject)
        selectedParticipants(previousObject)
    }
    const handleNext = () => {
        const nextObject = participantList[participantList.indexOf(selectedParticipantObj) + 1];
        setSelectedParticipantObj(nextObject)
        selectedParticipants(nextObject)
    }
    const selectedParticipants = (item) => {
        if (item && (item !== null || item !== '')) {
            let splitName = item.name.split(',')
            const firstName = splitName && splitName[1] && splitName[1].trim();
            const lastName = splitName && splitName[0] && splitName[0].trim();
            let replacedText = props.data && props.data.instructionText.replace("{FirstName}", firstName).replace("{firstName}", firstName)
            setInstructionText(replacedText && replacedText.replace("{LastName}", lastName).replace("{lastName}", lastName))
            setSelectedParticipantObj(item)
        } else {
            setInstructionText('')
            setSelectedParticipantObj(null)
        }
    }
    const setParticipantInstructions = (item) => {
        selectedParticipants(item)
    }
    const renderDialogContent = () => (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Box
                    sx={{
                        width: ' 60%',
                        display: 'flex',
                        // flexDirection: 'column',
                        flex: 0.3,
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 1
                        // '& .MuiFormControl-root': { width: '100%' },
                    }}>
                    {participantList && participantList.length > 0 ?
                    <>
                    <Button
                        variant="outlined"
                        onClick={handlePrev}
                        sx={{ width: '20%', mr: 1 }}>
                        Prev
                    </Button>
                     <Autocomplete
                        id="viewInstructions-autolist"
                        size="small"
                        sx={{width:"60%"}}
                        options={participantList}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                {option.name}
                            </Box>
                        )}
                        value={selectedParticipantObj}
                        onChange={(event, newValue) => {
                            setParticipantInstructions(newValue);
                        }}
                        // defaultValue={[top100Films[1]]}
                        renderInput={(params) => (
                            <TextField {...params} label="Participant"
                                error={props.error}
                                helperText={props.errorText} />
                        )}
                    />
                    <Button
                        variant="outlined"
                        onClick={handleNext}
                        sx={{ width: '20%', ml: 1 }}>
                        Next
                    </Button></> : null}
                </Box> 
                {instructionText && <Box
                    sx={{
                        width: ' 100%',
                        display: 'flex',
                        flexDirection: 'row',
                        // flex: 0.3,
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 1,
                        mt: 1,

                    }}>
                    <Paper sx={{ width: ' 100%', p: 1, ml: 4, mr: 4 }}>
                        <div style={{ fontFamily: 'Lato' }}
                            dangerouslySetInnerHTML={{
                                __html: instructionText && instructionText,
                            }} />
                    </Paper>
                </Box>}
            </Box>
        </>
    );

    const renderDialogActions2 = () =>
    (
        <Box style={buttonContent}>
            <Button
                variant="outlined"
                onClick={props.handleClose}
                sx={{
                    width: '100%'
                }}>
                Close
            </Button>
        </Box>
    )
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'xl'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions2}
        />
    )
}
